module.exports = __webpack_public_path__ + "img/question.b622b10b.svg";